import { observer } from "mobx-react-lite";
import ExecutorSharedView from "../shared/ExecutorSharedView";
import ExecutorOverview from "../../components/executor/overview/ExecutorOverview";

export default observer(function ExecutorDashboard() {
  return <ExecutorSharedView mainContent={<ExecutorOverview />} />;
});
